import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";

Vue.use(Vuex);


const load_and_preserve = (state, list, property) => {
  if (state[list].length) {
    const preserved = state[list].filter(c => c._id == state[property]._id);
    if (preserved.length) {
      state[property] = preserved[0];
    } else {
      state[property] = state[list][0];
    }
  } else {
    state[property] = null;
    return;
  }
}
const employee_sort = function (e1, e2) {
  return ("" + e1.code).localeCompare(e2.code);
}

export default new Vuex.Store({
  state: {
    bus: new Vue(),
    weekends: false,
    user: null,
    tasks: [],
    employee: null,
    employees: [],
    crew: null,
    crews: [],
    company: null,
    companies: [],
    paycodes: [],
    service_codes: [],
    maintenance_codes: [],
    equipment: [],
    materials: [],
    language: "en",
    sunday: null,
    times: [],
    crafts: [],
    next_start_time: {
      hr: "09",
      min: "00",
      ampm: "am"
    },
    last_day_entered: null
  },
  getters: {
    cell_times: (state) => (day, task) => {
      return state.times.filter((time) => {
        if (time.recorded_time.searchable.startsWith(day)) {
          if (time.category === "line-item" && time.lineItem && time.lineItem._id === task
            ._id)
            return true;
          else if (time.category === "equipment" && time.equipment && time.equipment
            ._id === task._id)
            return true;
          else if (time.category === "workorder" && time.workorder && time.workorder
            ._id === task._id)
            return true;
          else if (!task._id && time.category == task.category) {
            return true;
          }
          return false;
        }
      }).sort(function (t1, t2) {
        return t1.recorded_time.searchable - t2.recorded_time.searchable;
      })
    },
    task_times: (state) => (task) => {
      return state.times.filter((time) => {
        if (time.category === "line-item" && time.lineItem._id === task._id)
          return true;
        else if (time.category === "equipment" && time.equipment._id === task._id)
          return true;
        else if (time.category === "workorder" && time.workorder._id === task._id)
          return true;
        else if (time.category == task.category) {
          return true;
        }
        return false;
      });
    },
    unconfirmed: (state) => (task) => {

      const times = state.times.filter((time) => {
        if (time.category === "line-item" && time.lineItem && time.lineItem._id === task
          ._id) {
          return true;
        } else if (time.category === "equipment" && time.equipment && time.equipment
          ._id ===
          task._id)
          return true;
        else if (time.category === "workorder" && time.workorder && time.workorder._id ===
          task._id)
          return true;
        else if (!task._id && time.category == task.category) {
          return true;
        }
        return false;
      });

      return times.filter(t => !t.confirmed).length > 0;
    }
  },
  methods: {},
  actions: {

  },
  mutations: {
    start_time(state, data) {
      state.next_start_time = data.time;
      state.last_day_entered = data.day;
    },
    weekends(state, weekends) {
      state.weekends = weekends;
    },
    addons(state, addons) {
      state.equipment = addons.equipment;
      state.service_codes = addons.service_codes;
      state.maintenance_codes = addons.maintenance_codes;
      state.materials = addons.materials;
      state.paycodes = addons.paycodes;
    },
    load(state, stored) {
      state.user = stored.user;

      state.company = stored.company;
      state.crew = stored.crew;
      state.crews = stored.crews;
      state.employee = stored.employee;
      if (stored.employees) {
        state.employees = stored.employees.slice().sort(employee_sort);
      }
      state.companies = stored.companies;
      state.paycodes = stored.paycodes;
      state.service_codes = stored.service_codes;
      state.maintenance_codes = stored.maintenance_codes;
      state.equipment = stored.equipment;
      state.materials = stored.materials;
      state.language = stored.language;
      let m = moment();
      m = m.startOf('w');
      state.sunday = m.date();
    },
    language(state, language) {
      state.language = language;
    },
    refresh(state, payload) {
      // Called when a user clicks the refresh button.
      // Only replace the company list - then make sure the old company
      // is still there.  If so, then move on to the crew, then member.
      // If company, crew, or member is not present in the new list, default to first one.
      state.companies = payload.companies.filter(c => c.crews && c.crews.length > 0);
      load_and_preserve(state, 'companies', 'company');
      if (state.company) {
        state.crews = state.company.crews;
        load_and_preserve(state, 'crews', 'crew');
        if (state.crew && state.crew.members) {
          state.crew.employees = state.crew.members.slice().sort(employee_sort);
          state.employees = state.crew.employees;
          load_and_preserve(state, 'employees', 'employee');
          if (state.crew) {
            state.tasks = state.crew.tasks;
          }
        }
      }


    },
    login(state, user) {
      if (!user) {
        state.user = null;
        state.companies = [];
        state.company = null;
        state.crew = null;
        return;
      }
      let m = moment();
      m = m.startOf('w');
      state.sunday = m.toDate();

      state.user = user.user;

      // Company initialization
      state.companies = user.companies.filter(c => c.crews && c.crews.length > 0);
      state.company = state.companies.length ? state.companies[0] : null;
      if (state.companies.length > 0) {
        state.company = state.companies[0];
      } else {
        return;
      }

      // Crew initialization
      state.crews = state.company.crews;
      if (state.company.crews.length > 0) {
        state.crew = state.company.crews[0];
        state.tasks = state.crew.tasks;
      } else {
        return;
      }

      // Employee initialization
      if (state.crew.members) {
        state.employees = state.crew.members.slice().sort(employee_sort);
      }
      if (state.employees.length > 0) {
        state.employee = state.employees[0]
      } else {
        return;
      }

      state.language = user.langauge;
    },
    company(state, company) {
      state.company = company;
      if (company) {
        state.crews = state.company.crews;
        state.crew = null;
        if (state.company.crews.length > 0) {
          state.crew = state.company.crews[0];
          state.tasks = state.crew.tasks;
        } else {
          return;
        }
      }
    },
    crew(state, crew) {
      state.crew = crew;
      if (state.crew.members) {
        state.employees = state.crew.members.slice().sort(employee_sort);
      }

      state.employee = null;
      state.tasks = state.crew.tasks
      if (state.employees.length > 0) {
        state.employee = state.employees[0];
      } else {
        return;
      }
    },
    employee(state, employee) {
      state.employee = employee;
    },
    week_plus(state) {
      const m = moment(state.sunday);
      m.add(1, 'w');
      state.sunday = m.toDate();
    },
    week_minus(state) {
      const m = moment(state.sunday);
      m.add(-1, 'w');
      state.sunday = m.toDate();
    },
    times(state, times) {
      console.log(times.map(t => moment(t.start).format("YYYY-MM-DD")))
      Vue.set(state, "times", times);
    },
    crafts(state, crafts) {
      state.crafts = crafts;
    }
  },
  modules: {}
});
